<template>
    <span
        :class="{
            'text-success': value,
            'text-secondary': !value,
            'disabled': disabled
        }"
        @click="$emit('input', !value)"
    >
        <i
            class="fa fa-lg icon-button"
            :class="value ? 'fa-toggle-on' : 'fa-toggle-off'"
            :title="title"
        ></i>
    </span>
</template>
<script>

export default {
    name: 'ToggleSwitch',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        disabled(newVal) {
            if (newVal) {
                // this.$emit('input', this.value);
                console.log('ToggleSwitch is disabled, ignoring input changes.');
            }
        }
    }
};
</script>
<style scoped>
    .icon-button {
        transition: color 0.8s, filter 0.8s;
    }
    .text-success, .text-secondary {
        transition: color 0.8s;
    }
    .fa-toggle-on {
        transition: filter 0.8s;
    }
    .fa-toggle-off {
        transition: filter 0.8s;
        filter: grayscale(80%);
    }
    .disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed;
    }
</style>